import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router-dom";
import AdminHeader from "../components/AdminHeader";
import AdminSidebar from "../components/AdminSidebar";
import { listUsers } from "../services/portalApi";
import { setUsers } from "../store/usersSlice";
import PageLoader from "../components/PageLoader";
import styles from "./AdminLayout.module.css";

export default function AdminLayout() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [booting, setBooting] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    let alive = true;

    dispatch(setUsers([]));
    listUsers()
      .then((result) => {
        if (alive && result?.users) {
          dispatch(setUsers(result.users));
        }
      })
      .catch(() => null)
      .finally(() => {
        if (alive) {
          setBooting(false);
        }
      });

    const onResize = () => {
      if (window.innerWidth > 960) {
        setDrawerOpen(false);
      }
    };

    window.addEventListener("resize", onResize);
    return () => {
      alive = false;
      window.removeEventListener("resize", onResize);
    };
  }, [dispatch]);

  if (booting) {
    return (
      <div className={styles.shells}>
        <div className={styles.content}>
          <main className={styles.main}>
            <PageLoader label="Preparing admin workspace..." />
          </main>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.shell}>
      <AdminSidebar open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      {drawerOpen ? (
        <button
          type="button"
          className={styles.backdrop}
          onClick={() => setDrawerOpen(false)}
          aria-label="Close menu"
        />
      ) : null}
      <div className={styles.content}>
        <AdminHeader onMenuClick={() => setDrawerOpen(true)} />
        <main className={styles.main}>
          <Outlet context={{ booting }} />
        </main>
      </div>
    </div>
  );
}
